import { selectors } from './data'

// Localized
export function getLocalizedText(state) {
    return selectors.getLocalizedText(state.loadingBarReducer)
}

// Versions
export function getVersions(state) {
    return selectors.getVersions(state.loadingBarReducer)
}

// Steam
export function getSteam(state) {
    return selectors.getSteam(state.loadingBarReducer)
}

// Server names
export function getServerName(state) {
    return selectors.getServerName(state.loadingBarReducer)
}

// Progress
export function getProgress(state) {
    return selectors.getProgress(state.loadingBarReducer)
}

export function getProgressForServer(state, server) {
    return selectors.getProgressForServer(state.loadingBarReducer, server)
}

// Client text
export function getClientText(state) {
    return selectors.getClientText(state.loadingBarReducer)
}

// Patch notes
export function getPatchNotes(state) {
    return selectors.getPatchNotes(state.loadingBarReducer)
}



// WEBPACK FOOTER //
// ./src/features/LoadingBar/selectors.js